import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
  name: 'replaceMetaDate',
})
@Injectable({ providedIn: 'root' })

export class ReplaceMetaDatePipe implements PipeTransform {
  transform(value: string, today: Date = new Date(), count: number = 0): string {
    if (!value) return '';
    const monthYear = today.toLocaleString('en-US', { month: 'long', year: 'numeric' });
    const shortMonthYear = today.toLocaleString('en-US', { month: 'short', year: 'numeric' });
    const year = today.getFullYear().toString();
    const fullDate = today.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });
    value = value.replace(/\$metadate/g, year);
    value = value.replace(/\$metamy/g, monthYear);
    value = value.replace(/\$metasmy/g, shortMonthYear);
    value = value.replace(/\$metafulldate/g, fullDate);
    value = value.replace(/\$count/g, count > 0 ? count.toString() : '');
    return value;
  }
}
